import React, { useState } from "react";
import PreviewIcon from "../../../../../Assets/SettingsPages/PreviewIcon.svg";
import { PaymentsEmailReason } from "../../../../../Contracts/Settings";
import AnyPaymentEmailPreview from "./AnyPaymentEmailPreview";
import PaymentPagePreview from "./PaymentPagePreview";

export interface ConfigureEmailPreviewSectionProps {
  brandingCompanyName?: string;
  logoUrl?: string;
  emailLinkColor?: string;
  emailButtonColor?: string;
  paymentButtonColor?: string;
}

const EmailOptions = [
  {
    key: PaymentsEmailReason.FirstPayment,
    value: "First Payment Email"
  },
  {
    key: PaymentsEmailReason.UpcomingPayment,
    value: "Automated Payment Email"
  },
  {
    key: PaymentsEmailReason.PaymentReminder,
    value: "Payment Reminder Email"
  },
  {
    key: PaymentsEmailReason.PaymentOverdue,
    value: "Payment Overdue Email"
  },
  {
    key: PaymentsEmailReason.RequestPaymentMethod,
    value: "Request to Add Payment Method"
  },
  {
    key: "payment_page",
    value: "Payment Page"
  }
];

const ConfigureEmailPreviewSection: React.FC<ConfigureEmailPreviewSectionProps> = ({
  brandingCompanyName,
  logoUrl,
  emailLinkColor,
  emailButtonColor,
  paymentButtonColor
}) => {
  const [selectedOption, setSelectedOption] = useState<string>(PaymentsEmailReason.FirstPayment);
  return (
    <div className="col-span-2 border-gray-200 border-l p-8 overflow-y-auto">
      <div className="sticky flex flex-wrap justify-between">
        <div className="flex items-center space-x-3">
          <img src={PreviewIcon} alt="Preview" />
          <span className="font-semibold">Preview and Edit Content</span>
        </div>
        <select
          value={selectedOption}
          onChange={event => setSelectedOption(event.target.value)}
          className="px-2 py-1 border border-gray-300 rounded"
        >
          {EmailOptions.map(({ key, value }) => (
            <option key={key} value={key}>
              {value}
            </option>
          ))}
        </select>
      </div>

      {selectedOption === "payment_page" ? (
        <PaymentPagePreview
          paymentButtonColor={paymentButtonColor}
          brandingCompanyName={brandingCompanyName}
        />
      ) : (
        <AnyPaymentEmailPreview
          logoUrl={logoUrl}
          brandingCompanyName={brandingCompanyName}
          emailButtonColor={emailButtonColor}
          emailLinkColor={emailLinkColor}
          paymentsEmailReason={selectedOption as PaymentsEmailReason}
        />
      )}
    </div>
  );
};

export default ConfigureEmailPreviewSection;
